import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Stack, Label, Text, mergeStyleSets, Icon, Image } from '@fluentui/react';
import { NeutralColors } from '@fluentui/theme';
import { RatingPercentages } from './ratingPercentages';
import microsoftLogo from '@shared/images/microsoft-icon.svg';
const contentStyles = mergeStyleSets({
    ratingSummaryContainer: [
        'ratingSummaryContainer',
        {
            minWidth: 280
        }
    ],
    singleInternalRatingSourceImage: {
        width: 16,
        height: 16,
        marginRight: 10,
        marginTop: 3
    },
    ratingSummaryAverageSection: [
        'ratingSummaryAverageSection',
        {
            margin: '16px 0'
        }
    ]
});
export function getPercentagesOfTotal(params) {
    const percentages = params.totalRatings ? params.timesRated * 100 / params.totalRatings : 0;
    return Math.round(percentages);
}
export function getEmptyRatingSummary() {
    return {
        AverageRating: 0,
        TotalRatings: 0,
        Source: '',
        OfferId: null,
        CreatedAt: null,
        StarsDistribution: {
            OneStars: 0,
            TwoStars: 0,
            ThreeStars: 0,
            FourStars: 0,
            FiveStars: 0
        }
    };
}
export function getAverageRatingToDisplay(ratingSummary) {
    return ratingSummary.AverageRating && !isNaN(ratingSummary.AverageRating) ? ratingSummary.AverageRating.toFixed(1) : '0';
}
export const renderRatingPercentagesByNumOfStars = (numOfStars, timesRated, totalRatings, context)=>{
    return /*#__PURE__*/ _jsx(RatingPercentages, {
        context: context,
        numberOfStars: numOfStars,
        percentagesOfTotal: getPercentagesOfTotal({
            timesRated,
            totalRatings
        })
    });
};
export const RatingSummary = ({ ratingSummary = getEmptyRatingSummary(), context = null, title = 'Rating Summary' })=>{
    var _totalRatingSummary_StarsDistribution, _totalRatingSummary_StarsDistribution1, _totalRatingSummary_StarsDistribution2, _totalRatingSummary_StarsDistribution3, _totalRatingSummary_StarsDistribution4;
    const totalRatingSummary = ratingSummary || getEmptyRatingSummary();
    const averageRating = getAverageRatingToDisplay(totalRatingSummary);
    const ratingSummaryAriaText = context === null || context === void 0 ? void 0 : context.locParams('Reviews_Summary_AriaText', [
        averageRating,
        '5',
        `${totalRatingSummary.TotalRatings}`
    ]);
    const iconStyles = {
        root: [
            'ratingSummaryStar',
            {
                fontSize: 17
            },
            !totalRatingSummary.TotalRatings && {
                color: NeutralColors.gray90
            }
        ]
    };
    var _totalRatingSummary_StarsDistribution_FiveStars, _totalRatingSummary_StarsDistribution_FourStars, _totalRatingSummary_StarsDistribution_ThreeStars, _totalRatingSummary_StarsDistribution_TwoStars, _totalRatingSummary_StarsDistribution_OneStars;
    return /*#__PURE__*/ _jsxs("div", {
        className: contentStyles.ratingSummaryContainer,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        src: microsoftLogo,
                        className: contentStyles.singleInternalRatingSourceImage,
                        alt: "Microsoft Logo"
                    }),
                    /*#__PURE__*/ _jsx("text", {
                        className: "ratingSummaryTitle",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: contentStyles.ratingSummaryAverageSection,
                "aria-label": ratingSummaryAriaText,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        iconName: totalRatingSummary.TotalRatings ? 'FavoriteStarFill' : 'FavoriteStar',
                        styles: iconStyles,
                        "aria-label": context === null || context === void 0 ? void 0 : context.loc('Ratings_Review_Star', 'Ratings review star')
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "ratingSummaryAverageSectionText",
                        children: [
                            /*#__PURE__*/ _jsx(Label, {
                                className: "ratingSummaryNumOfStars",
                                children: averageRating
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                className: "numOfRatingText",
                                variant: "mediumPlus",
                                children: [
                                    "(",
                                    totalRatingSummary.TotalRatings,
                                    " ",
                                    context === null || context === void 0 ? void 0 : context.loc('Global_Loc_ratingsLower', 'ratings'),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            totalRatingSummary.TotalRatings >= 5 && /*#__PURE__*/ _jsxs(Stack, {
                tokens: {
                    childrenGap: 2,
                    padding: 1
                },
                children: [
                    renderRatingPercentagesByNumOfStars(5, (_totalRatingSummary_StarsDistribution_FiveStars = (_totalRatingSummary_StarsDistribution = totalRatingSummary.StarsDistribution) === null || _totalRatingSummary_StarsDistribution === void 0 ? void 0 : _totalRatingSummary_StarsDistribution.FiveStars) !== null && _totalRatingSummary_StarsDistribution_FiveStars !== void 0 ? _totalRatingSummary_StarsDistribution_FiveStars : 0, totalRatingSummary.TotalRatings, context),
                    renderRatingPercentagesByNumOfStars(4, (_totalRatingSummary_StarsDistribution_FourStars = (_totalRatingSummary_StarsDistribution1 = totalRatingSummary.StarsDistribution) === null || _totalRatingSummary_StarsDistribution1 === void 0 ? void 0 : _totalRatingSummary_StarsDistribution1.FourStars) !== null && _totalRatingSummary_StarsDistribution_FourStars !== void 0 ? _totalRatingSummary_StarsDistribution_FourStars : 0, totalRatingSummary.TotalRatings, context),
                    renderRatingPercentagesByNumOfStars(3, (_totalRatingSummary_StarsDistribution_ThreeStars = (_totalRatingSummary_StarsDistribution2 = totalRatingSummary.StarsDistribution) === null || _totalRatingSummary_StarsDistribution2 === void 0 ? void 0 : _totalRatingSummary_StarsDistribution2.ThreeStars) !== null && _totalRatingSummary_StarsDistribution_ThreeStars !== void 0 ? _totalRatingSummary_StarsDistribution_ThreeStars : 0, totalRatingSummary.TotalRatings, context),
                    renderRatingPercentagesByNumOfStars(2, (_totalRatingSummary_StarsDistribution_TwoStars = (_totalRatingSummary_StarsDistribution3 = totalRatingSummary.StarsDistribution) === null || _totalRatingSummary_StarsDistribution3 === void 0 ? void 0 : _totalRatingSummary_StarsDistribution3.TwoStars) !== null && _totalRatingSummary_StarsDistribution_TwoStars !== void 0 ? _totalRatingSummary_StarsDistribution_TwoStars : 0, totalRatingSummary.TotalRatings, context),
                    renderRatingPercentagesByNumOfStars(1, (_totalRatingSummary_StarsDistribution_OneStars = (_totalRatingSummary_StarsDistribution4 = totalRatingSummary.StarsDistribution) === null || _totalRatingSummary_StarsDistribution4 === void 0 ? void 0 : _totalRatingSummary_StarsDistribution4.OneStars) !== null && _totalRatingSummary_StarsDistribution_OneStars !== void 0 ? _totalRatingSummary_StarsDistribution_OneStars : 0, totalRatingSummary.TotalRatings, context)
                ]
            })
        ]
    });
};
